// Reine Regeln der Benutzer-Reiter — getestet (users-helpers.test.ts).

import type { InstanceUsersResponse } from "../../api/types";

export const USER_ERRORS: Record<string, string> = {
  invalid_email: "Keine gültige E-Mail-Adresse.",
  invalid_role: "Diese Rolle gibt es in der Instanz nicht (mehr).",
  user_exists: "Ein Konto mit dieser E-Mail gibt es schon.",
  license_user_limit: "Die Lizenz erlaubt keine weiteren Benutzer.",
  license_full: "Alle Plätze dieser Lizenz sind vergeben.",
  invalid_license: "Diese Lizenz gibt es in der Instanz (noch) nicht — erst „Übernehmen“.",
};

/** Ob die Instanz mit Benutzer-Lizenzen läuft (docs/11 8e). */
export const seatsOn = (data: Pick<InstanceUsersResponse, "seat_mode">): boolean => Boolean(data.seat_mode && data.seat_mode !== "off");

/** Die Standard-Lizenz, wenn ein Platz frei ist — sonst die erste mit freiem Platz, sonst keine. */
export function preferredSeat(data: Pick<InstanceUsersResponse, "seats" | "default_seat">): string {
  const free = (x: { used: number; count: number }) => x.used < x.count;
  return (data.seats.find((x) => x.key === data.default_seat && free(x)) ?? data.seats.find(free))?.key ?? "";
}

/** Die Rolle, die vorausgewählt ist: die Vorgabe der Instanz, sonst die erste. */
export function defaultRole(data: Pick<InstanceUsersResponse, "roles">): string {
  const roles = data.roles ?? [];
  const r = roles.find((x) => x.is_default) ?? roles[0];
  return r ? String(r.id) : "";
}

export interface AddUserState {
  email: string;
  name: string;
  roleId: string;
  licenseKey: string;
  admin: boolean;
}

/**
 * Der Rumpf für `POST /tenants/:id/users`. Ein Admin hat keine Rolle (sie
 * zählt dann nicht), ohne Rollenliste auch nicht; eine Lizenz nur, wenn die
 * Instanz Lizenzen führt.
 */
export function addUserBody(s: AddUserState, opts: { hasRoles: boolean; seatsOn: boolean }) {
  return {
    email: s.email.trim(),
    name: s.name.trim() || undefined,
    admin: s.admin,
    role_id: s.admin || !opts.hasRoles ? null : Number(s.roleId),
    license_key: opts.seatsOn ? (s.licenseKey || null) : null,
  };
}
